import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M1.8 10.8L.4 8.7c6.5-4.2 14.1-6.4 22.1-6.4v2.5c-7.4 0-14.6 2.1-20.7 6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M1.4 18.5L.8 16c6.4-1.3 13.9-2 21.7-2v2.5c-7.6 0-14.9.6-21.1 2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M22.5 29.1c-7.8 0-15.3-.7-21.7-2.1l.5-2.4c6.2 1.3 13.5 2 21.1 2v2.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M22.5 40.8c-7.9 0-15.6-2.2-22.1-6.4l1.3-2.1c6.1 3.9 13.3 6 20.7 6v2.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M43.2 13.1c-6.1-3.9-13.3-6-20.7-6V4.6c7.9 0 15.6 2.2 22.1 6.4l-1.4 2.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M43.6 20.9c-6.2-1.3-13.5-2-21.1-2v-2.5c7.8 0 15.3.7 21.7 2.1l-.6 2.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M22.5 31.8v-2.5c7.6 0 14.9-.7 21.1-2l.5 2.4c-6.3 1.4-13.8 2.1-21.6 2.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M22.5 43v-2.5c7.5 0 14.6-2.1 20.7-6l1.3 2.1c-6.4 4.2-14.1 6.4-22 6.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M42 2.5c.3 0 .5.2.5.5v39c0 .3-.2.5-.5.5H3c-.3 0-.5-.2-.5-.5V3c0-.3.2-.5.5-.5h39M42 0H3C1.3 0 0 1.3 0 3v39c0 1.7 1.3 3 3 3h39c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3z"
		})
	]
});
export default SvgIcon;
